import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import {
  useLocation,
  useNavigate,
} from 'react-router-dom';

import Icon from '@/components/Icon';
import { routeConfig } from '@/router';

// 底部导航栏组件
const Foot = () => {
    const { t } = useTranslation()
    const { pathname } = useLocation(); // 获取当前路由路径
    const router = useNavigate();       // 路由跳转方法

    // 计算所有 foot 为 true 的路由节点，使用pathname来遍历出当前路由是否展示 foot 用于底部导航显示
    // footRoutes 是可以渲染的底部导航路由节点
    // current 是当前路由是否展示 foot
    const footShow = useMemo(() => {
        const result: any[] = [];

        // 遍历路由配置，收集 foot 为 true 的节点
        const traverse = (nodes: any[]) => {
            for (const node of nodes) {
                if (node.foot && node.path) {
                    result.push(node);
                }
                if (Array.isArray(node.children)) {
                    traverse(node.children);
                }
            }
        };

        traverse(routeConfig);

        // 去重并查找当前激活的底部路由
        const footRoutes = Array.from(new Set(result));
        const current = footRoutes.find((item) => pathname === item.path);
        return { footRoutes, current };
    }, [pathname]);


    return (
        <div className={`${footShow.current ? '' : 'hidden'} box-border h-22 flex items-center justify-around fixed bottom-0 left-0 right-0 bg-white border-t border-f1 md:hidden`}>
            {/* 渲染底部导航项 */}
            {footShow.footRoutes.map((item, index) => (
                <div
                    onClick={() => router(item.path)}
                    key={index}
                    className={`flex flex-col items-center ${item.path === pathname ? "text-mainBlack" : " text-ab"} `}
                >
                    {/* 图标，首页特殊处理填充色 */}
                    <Icon
                        modifySvgElement={item.path === '/' ? (svg) => {
                            // 修改 rect 填充色为 currentColor
                            const rects = svg.querySelectorAll('rect');
                            rects.forEach((rect) => {
                                rect.setAttribute('fill', 'currentColor');
                            });
                        } : undefined}
                        src={item.icon}
                        className='w-6 mb-1'
                    />
                    <span className='text-3.25'>{t(`router.${item.footTitle}`)}</span>
                </div>
            ))}
        </div>
    );
};

export default Foot;